// import React, { useState } from "react";
// import { handleUpdate } from "./updatePortofolioHandler";
// import TutorialGambar from "../../imageTutorial";
// import { placeholderImage, isValidUrl } from "../../invalidImage";
// import { Toggle } from "rsuite";

// const ModalUpdatePortofolio = ({ portofolio, onClose }) => {
//   const [imageUrl, setImageUrl] = useState(portofolio.img);
//   const [name, setName] = useState(portofolio.name);
//   const [link, setLink] = useState(portofolio.link);
//   const [status, setStatus] = useState(portofolio.status);
//   const [type, setType] = useState(portofolio.type);

//   return (
//     <div>
//       <div
//         id="crud-modal"
//         aria-hidden="true"
//         className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-full overflow-y-auto overflow-x-hidden bg-black bg-opacity-50"
//       >
//         <div className="relative p-4 w-full max-w-4xl max-h-full">
//           <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
//             <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
//               <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
//                 Update Portofolio
//               </h3>
//               <button
//                 type="button"
//                 className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
//                 onClick={onClose}
//               >
//                 <svg
//                   className="w-3 h-3"
//                   aria-hidden="true"
//                   xmlns="http://www.w3.org/2000/svg"
//                   fill="none"
//                   viewBox="0 0 14 14"
//                 >
//                   <path
//                     stroke="currentColor"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                     d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
//                   />
//                 </svg>
//                 <span className="sr-only">Close modal</span>
//               </button>
//             </div>
//             <form
//               className="p-4 md:p-5"
//               onSubmit={(e) =>
//                 handleUpdate(e, portofolio.id, name, imageUrl, link, status, type, onClose)
//               }
//             >
//               <div className="grid gap-4 mb-4 grid-cols-1 md:grid-cols-2">
//                 <div>
//                   <div className="col-span-2">
//                     <label
//                       htmlFor="name"
//                       className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
//                     >
//                       Name
//                     </label>
//                     <input
//                       type="text"
//                       name="name"
//                       id="name"
//                       className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
//                       placeholder="Type portofolio name"
//                       value={name}
//                       onChange={(e) => setName(e.target.value)}
//                     />
//                   </div>
//                   <div className="col-span-2">
//                     <label
//                       htmlFor="link"
//                       className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
//                     >
//                       Link
//                     </label>
//                     <input
//                       type="text"
//                       name="link"
//                       id="link"
//                       className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
//                       placeholder="Paste portofolio link"
//                       value={link}
//                       onChange={(e) => setLink(e.target.value)}
//                     />
//                   </div>
//                   <div className="col-span-2">
//                     <label
//                       htmlFor="imageUrl"
//                       className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
//                     >
//                       Image URL
//                     </label>
//                     <input
//                       type="text"
//                       name="imageUrl"
//                       id="imageUrl"
//                       className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
//                       placeholder="Paste image URL here"
//                       value={imageUrl}
//                       onChange={(e) => setImageUrl(e.target.value)}
//                     />
//                   </div>
//                   {imageUrl && (
//                     <div className="relative mt-3 h-36">
//                       <img
//                         src={isValidUrl(imageUrl) ? imageUrl : placeholderImage}
//                         alt="Selected"
//                         className="rounded-lg object-contain h-full w-full"
//                       />
//                     </div>
//                   )}
//                   <div className="col-span-2">
//                     <label
//                       htmlFor="type"
//                       className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
//                     >
//                       Type
//                     </label>
//                     <input
//                       type="text"
//                       name="type"
//                       id="type"
//                       className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
//                       placeholder="Enter portofolio type"
//                       value={type}
//                       onChange={(e) => setType(e.target.value)}
//                     />
//                   </div>
//                   <div className="col-span-2 flex items-center mt-4">
//                     <label
//                       htmlFor="status"
//                       className="text-sm font-medium text-gray-900 dark:text-white mr-2"
//                     >
//                       Status:
//                     </label>
//                     <Toggle
//                       checked={status === 1}
//                       onChange={(value) => setStatus(value ? 1 : 0)}
//                       size="sm"
//                     />
//                   </div>
//                   <button
//                     type="submit"
//                     className="mt-4 text-white inline-flex items-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
//                   >
//                     <svg
//                       className="me-1 -ms-1 w-5 h-5"
//                       fill="currentColor"
//                       viewBox="0 0 20 20"
//                       xmlns="http://www.w3.org/2000/svg"
//                     >
//                       <path
//                         fillRule="evenodd"
//                         d="M10 5a1 1 011 1v3h3a1 1 110 2h-3v3a1 1 11-2 0v-3H6a1 1 110-2h3V6a1 1 111-1z"
//                         clipRule="evenodd"
//                       ></path>
//                     </svg>
//                     Update portofolio
//                   </button>
//                 </div>
//                 <TutorialGambar />
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ModalUpdatePortofolio;
import React, { useState, useEffect } from "react";
import { handleUpdate } from "./updatePortofolioHandler";
import ImageUploader from "../ImageUploader";
import { Toggle } from "rsuite";
import { fetchPortofolioCategories } from "../../../api/portofolioAPI";

const ModalUpdatePortofolio = ({ portofolio, onClose }) => {
  const [imageUrl, setImageUrl] = useState(portofolio.img);
  const [name, setName] = useState(portofolio.name);
  const [link, setLink] = useState(portofolio.link);
  const [status, setStatus] = useState(portofolio.status);
  const [type, setType] = useState(portofolio.type);
  const [category, setCategory] = useState(portofolio.category ?? "");
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");

  useEffect(() => {
    fetchPortofolioCategories().then(setCategories).catch(() => {});
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Overlay dengan blur halus */}
      <div 
        className="absolute inset-0 bg-gray-900/40 backdrop-blur-[2px] transition-opacity" 
        onClick={onClose} 
      />

      {/* Kontainer Modal */}
      <div className="relative w-full max-w-5xl bg-white rounded-2xl shadow-2xl overflow-hidden transform transition-all border border-gray-100">
        
        {/* Header - Lebih Bersih */}
        <div className="flex items-center justify-between p-6 border-b border-gray-50">
          <div>
            <h3 className="text-2xl font-extrabold text-gray-900 tracking-tight">
              Update Portfolio
            </h3>
            <p className="text-sm text-gray-500 mt-1">Make changes to your project details below.</p>
          </div>
          <button
            type="button"
            className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-all"
            onClick={onClose}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Form Body */}
        <form
          className="p-6 overflow-y-auto max-h-[85vh]"
          onSubmit={(e) =>
            handleUpdate(e, portofolio.id, name, imageUrl, link, status, type, onClose, category)
          }
        >
          <div className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div className="md:col-span-2">
                  <label className="block mb-2 text-sm font-bold text-gray-700 tracking-wide uppercase text-[11px]">
                    Project Name
                  </label>
                  <input
                    type="text"
                    required
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all placeholder:text-gray-400 text-gray-800"
                    placeholder="Enter project name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block mb-2 text-sm font-bold text-gray-700 tracking-wide uppercase text-[11px]">
                    Type
                  </label>
                  <input
                    type="text"
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all text-gray-800"
                    placeholder="Web App, UI/UX, etc."
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block mb-2 text-sm font-bold text-gray-700 tracking-wide uppercase text-[11px]">
                    Category
                  </label>
                  <select
                    value={newCategory ? "" : category}
                    onChange={(e) => { setCategory(e.target.value); setNewCategory(""); }}
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all text-gray-800"
                  >
                    <option value="">-- Pilih / Buat Baru --</option>
                    {categories.map((c) => (
                      <option key={c} value={c}>{c}</option>
                    ))}
                  </select>
                  <input
                    type="text"
                    className="mt-2 w-full px-4 py-2.5 bg-gray-50 border border-dashed border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all text-sm text-gray-800 placeholder:text-gray-400"
                    placeholder="Atau ketik kategori baru..."
                    value={newCategory}
                    onChange={(e) => { setNewCategory(e.target.value); setCategory(e.target.value); }}
                  />
                </div>

                <div>
                  <label className="block mb-2 text-sm font-bold text-gray-700 tracking-wide uppercase text-[11px]">
                    Project URL
                  </label>
                  <input
                    type="text"
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all text-gray-800"
                    placeholder="https://example.com"
                    value={link}
                    onChange={(e) => setLink(e.target.value)}
                  />
                </div>
              </div>

              <ImageUploader
                value={imageUrl}
                onChange={setImageUrl}
                label="Gambar Portofolio"
              />

              {/* Status Section */}
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-2xl border border-gray-100">
                <div className="flex flex-col">
                  <span className="text-sm font-bold text-gray-800">Public Visibility</span>
                  <span className="text-xs text-gray-500">Enable this to show project on your public profile</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className={`text-[10px] font-bold uppercase tracking-widest ${status === 1 ? 'text-green-500' : 'text-gray-400'}`}>
                    {status === 1 ? 'Active' : 'Hidden'}
                  </span>
                  <Toggle
                    checked={status === 1}
                    onChange={(value) => setStatus(value ? 1 : 0)}
                    size="md"
                  />
                </div>
              </div>

              {/* Footer Actions */}
              <div className="flex items-center gap-3 pt-2">
                <button
                  type="submit"
                  className="flex-1 md:flex-none px-10 py-3.5 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-xl shadow-lg shadow-blue-200 transition-all active:scale-95 flex items-center justify-center gap-2"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  Save Changes
                </button>
                <button
                  type="button"
                  onClick={onClose}
                  className="px-6 py-3.5 bg-white border border-gray-200 text-gray-600 font-bold rounded-xl hover:bg-gray-50 transition-all"
                >
                  Cancel
                </button>
              </div>

          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalUpdatePortofolio;